/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateItemTypeFieldsRequestSchema = z.object({
  fieldIds: z.array(z.int()),
});
